import * as React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import Typography from '../components/Typography';
import TextField from '../components/TextField';
import Button from '../components/Button';
import { useNavigate } from 'react-router-dom';
import productCTAWatchWebp from "../components/img/productCTAWatch.webp";
import productCTAWatchPng from "../components/img/productCTAWatch.png"
import productCTAImageDots from "../components/img/productCTAImageDots.png";
import useWindowWide from '../components/useWindowWide';
import { useWebPSupportCheck } from '../components/img/useWebPSupportCheck';

function ProductCTA() {
  const navigate = useNavigate();
  const isWide = useWindowWide(750);
  const supportsWebP = useWebPSupportCheck();

  const [userEmail, setUserEmail] = React.useState("");

  const handleSubmit = (event) => {
    event.preventDefault();
    navigate('/sign-up', { state: { userEmail } });
  };

  return (
    <Container component="section" sx={{ mt: 10, display: 'flex' }}>
      <Grid container>
        <Grid item xs={12} md={6} sx={{ zIndex: 1 }}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              bgcolor: 'warning.main',
              py: 8,
              px: 3,
            }}
          >
            <Box component="form" onSubmit={handleSubmit} sx={{ maxWidth: 400 }}>
              <Typography variant="h2" component="h2" gutterBottom>
                Get started
              </Typography>
              <Typography variant="h5">
                Signing up is quick and easy.
              </Typography>
              <TextField
                noBorder
                placeholder="Your email"
                variant="standard"
                autoComplete="email"
                sx={{ width: '100%', mt: 3, mb: 2 }}
                value={userEmail}
                onInput={e => setUserEmail(e.target.value)}
              />
              <Button
                type="submit"
                color="primary"
                variant="contained"
                sx={{ width: '100%' }}
              >
                Sign up now
              </Button>
            </Box>
          </Box>
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
          sx={{ display: { md: 'block', xs: 'none' }, position: 'relative' }}
        >
          <Box
            sx={{
              position: 'absolute',
              top: -67,
              left: -67,
              right: 0,
              bottom: 0,
              width: '100%',
              background: `url(${productCTAImageDots})`,
            }}
          />
          {isWide &&
            <Box
              component="img"
              src={supportsWebP ? productCTAWatchWebp : productCTAWatchPng}
              alt="call to action"
              sx={{
                position: 'absolute',
                top: -28,
                left: -28,
                right: 0,
                bottom: 0,
                width: '100%',
                maxWidth: 600,
              }}
            />
          }
        </Grid>
      </Grid>
    </Container>
  );
}

export default ProductCTA;